/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Reading_File_ToastInputs */

const en_plain_text_import_reading_file_toast = /** @type {(inputs: Plain_Text_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reading file contents...`)
};

const fr_plain_text_import_reading_file_toast = /** @type {(inputs: Plain_Text_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecture du contenu du fichier...`)
};

const de_plain_text_import_reading_file_toast = /** @type {(inputs: Plain_Text_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiinhalt wird gelesen...`)
};

const it_plain_text_import_reading_file_toast = /** @type {(inputs: Plain_Text_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettura del contenuto del file...`)
};

const ru_plain_text_import_reading_file_toast = /** @type {(inputs: Plain_Text_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чтение содержимого файла...`)
};

const es_plain_text_import_reading_file_toast = /** @type {(inputs: Plain_Text_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendo el contenido del archivo...`)
};

const zh_cn2_plain_text_import_reading_file_toast = /** @type {(inputs: Plain_Text_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在读取文件内容...`)
};

const ja_plain_text_import_reading_file_toast = /** @type {(inputs: Plain_Text_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルの内容を読み込んでいます...`)
};

const hi_plain_text_import_reading_file_toast = /** @type {(inputs: Plain_Text_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल की सामग्री पढ़ी जा रही है...`)
};

const pt_pt2_plain_text_import_reading_file_toast = /** @type {(inputs: Plain_Text_Import_Reading_File_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lendo o conteúdo do arquivo...`)
};

/**
* | output |
* | --- |
* | "Reading file contents..." |
*
* @param {Plain_Text_Import_Reading_File_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_reading_file_toast = /** @type {((inputs?: Plain_Text_Import_Reading_File_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Reading_File_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_reading_file_toast(inputs)
	if (locale === "de") return de_plain_text_import_reading_file_toast(inputs)
	if (locale === "it") return it_plain_text_import_reading_file_toast(inputs)
	if (locale === "ru") return ru_plain_text_import_reading_file_toast(inputs)
	if (locale === "es") return es_plain_text_import_reading_file_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_reading_file_toast(inputs)
	if (locale === "ja") return ja_plain_text_import_reading_file_toast(inputs)
	if (locale === "hi") return hi_plain_text_import_reading_file_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_reading_file_toast(inputs)
	return en_plain_text_import_reading_file_toast(inputs)
});